import { render } from "./OwnerRegistrationForm.vue?vue&type=template&id=f043fc66"
import script from "./OwnerRegistrationForm.vue?vue&type=script&lang=js"
export * from "./OwnerRegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__